module.exports = __webpack_public_path__ + "img/x3.a4d31193.png";